// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Mbbi","image":"Header_image__2bVhR","name":"Header_name__2u9ma","info":"Header_info__1SR5K","infoRow":"Header_infoRow__3-NIh"};